import { RegionViewModel } from "../viewmodels/RegionViewModel.js";
import { AppShellViewModel } from "../viewmodels/AppShellViewModel.js";
import logoVertical_default from "../../../assets/Images/logoVertical.png.js";
import { OrganizationClientAccessBlocked } from "../../Organizations/shared/OrganizationClientAccessBlocked.js";
import "react";
import { Icon } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/components/AccessGuard.tsx
function AccessGuard({ children }) {
	const shellVM = useSingleton(AppShellViewModel);
	const regionVM = useSingleton(RegionViewModel);
	if (shellVM.isClientAccessBlocked && shellVM.identityInfo) return /* @__PURE__ */ jsx(OrganizationClientAccessBlocked, { identityInfo: shellVM.identityInfo });
	if (!regionVM.state.initialized) return null;
	if (!shellVM.identityInfo?.regions?.length || !regionVM.state.currentRegionId) return /* @__PURE__ */ jsxs("div", {
		className: "h-full w-full",
		children: [/* @__PURE__ */ jsx("div", {
			className: "pt-xl flex justify-center",
			children: /* @__PURE__ */ jsx("img", {
				alt: "THERMS logo",
				src: logoVertical_default
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "flex justify-center",
			children: /* @__PURE__ */ jsx("div", {
				className: "my-xxl p-base text-color-critical max-w-(--breakpoint-xxl) text-center text-lg",
				children: "You do not have access to any Regions in this Organization. Contact an Organization administrator to resolve your User profile access."
			})
		})]
	});
	if (!shellVM.hasAnyApps) return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		children: /* @__PURE__ */ jsx("div", {
			className: "my-xxl p-base text-color-critical text-center text-lg",
			children: "You do not have access to any apps in this Organization"
		})
	});
	if (!shellVM.hasAccessToCurrentApp) {
		const currentApp = shellVM.currentApp;
		const appList = shellVM.appList;
		return /* @__PURE__ */ jsxs("div", {
			className: "h-full w-full",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "my-xxl p-base text-color-caution text-center text-lg",
					children: [
						"You do not have access to the",
						" ",
						/* @__PURE__ */ jsx("strong", { children: currentApp?.name || "" }),
						" app in this Organization."
					]
				}),
				/* @__PURE__ */ jsx("div", {
					className: "my-base text-color-neutral text-center font-bold",
					children: "Select App"
				}),
				/* @__PURE__ */ jsx("div", {
					className: "flex justify-center",
					children: /* @__PURE__ */ jsx("div", {
						className: "space-sm flex w-full flex-wrap justify-center md:w-2/3",
						children: appList.map((app) => /* @__PURE__ */ jsxs("div", {
							className: "m-xs bg-main p-base w-48 cursor-pointer truncate rounded text-center",
							onClick: () => {
								document.location.href = app.link;
							},
							children: [
								/* @__PURE__ */ jsx(Icon, { Icon: app.icon }),
								" ",
								app.name
							]
						}, app.id))
					})
				})
			]
		});
	}
	return /* @__PURE__ */ jsx(Fragment$1, { children });
}
//#endregion
export { AccessGuard };

//# sourceMappingURL=AccessGuard.js.map